import { render } from "./ClassSetDialog.vue?vue&type=template&id=df445d1c"
import script from "./ClassSetDialog.vue?vue&type=script&lang=js"
export * from "./ClassSetDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__